module.exports = __webpack_public_path__ + "img/RegionalPartnerBannerImage.90d4f59e.png";